// extracted by mini-css-extract-plugin
export default {"orderInfoCard__controls":"orderInfoCard_orderInfoCard__controls__0Zzoa","orderInfoCard__title":"orderInfoCard_orderInfoCard__title__N8CYX"};